import React, { useState } from "react";
import PropTypes from "prop-types";

import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import TextField from "@mui/material/TextField";

import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";

import { TAG_ERRORS } from "./data";

function Tag({ index, tag, handleTagValueChange, handleTagDelete, tags = [] }) {
  const [keyError, setKeyError] = useState(false);

  const onKeyInputBlur = (e) => {
    if (e.target.value === "") setKeyError(TAG_ERRORS.EMTPY_KEY);
    else if (tags.some((_tag, _index) => _tag.TagKey === e.target.value && _index !== index))
      setKeyError(TAG_ERRORS.DUPLICATE_KEY);
    else setKeyError(false);
  };
  return (
    <>
      <Grid size={5.75}>
        <TextField
          required
          variant="outlined"
          inputProps={{ maxLength: 50 }}
          fullWidth
          label="Key"
          value={tag.TagKey}
          onChange={(e) => handleTagValueChange(index, "TagKey", e.target.value)}
          onBlur={onKeyInputBlur}
          error={keyError}
          helperText={keyError}
        />
      </Grid>
      <Grid size={5.75}>
        <TextField
          variant="outlined"
          fullWidth
          label="Value"
          value={tag.TagValue}
          onChange={(e) => handleTagValueChange(index, "TagValue", e.target.value)}
        />
      </Grid>
      <Grid
        sx={{ display: "flex", justifyContent: "center", maxHeight: "70px", minHeight: "70px" }}
        size={0.5}>
        <IconButton aria-label="delete" onClick={() => handleTagDelete(index)}>
          <DeleteOutlineOutlinedIcon color="error" />
        </IconButton>
      </Grid>
    </>
  );
}

Tag.propTypes = {
  index: PropTypes.number.isRequired,
  tag: PropTypes.object.isRequired,
  tags: PropTypes.array.isRequired,
  handleTagValueChange: PropTypes.func.isRequired,
  handleTagDelete: PropTypes.func.isRequired,
};

export default Tag;
